<template>
  <div class="question-component-container">
    <question-answered
      v-if="answered"
      :cases-enabled="casesEnabled"
      :correct="correct"
      :correct-text="correctText"
      :flashcard="flashcard"
      :metadata="metadata"
      :show-metadata="showMetadata"
      @flashcard-aa-clicked="$emit('flashcard-aa-clicked', $event)"
    />
    <question-unanswered
      v-else
      :category="category"
      :cases-enabled="casesEnabled"
      :flashcard="flashcard"
      @flashcard-aa-clicked="$emit('flashcard-aa-clicked', $event)"
    />
    <div
      v-if="sata"
      class="sata"
    >
      Select All That Apply
    </div>
    <div
      v-if="exhibitsEnabled"
      class="associated-exhibits"
      @click="showExhibits"
    >
      View Exhibits
    </div>
    <exhibit-modal
      :items="exhibitItems"
      :show="exhibitModalVisibility"
      @close-modal="closeExhibitModal"
    />
  </div>
</template>

<script>
import ExhibitModal from '@components/singletons/exhibit-modal';
import QuestionAnswered from '@components/flashcards/fragments/question-answered';
import QuestionUnanswered from '@components/flashcards/fragments/question-unanswered';

export default {
  name: 'FlashcardQuestion',
  components: { ExhibitModal, QuestionAnswered, QuestionUnanswered },
  props: {
    answered: {
      type: Boolean,
      default: false,
    },
    category: {
      type: Object,
      default: () => ({}),
    },
    correct: {
      type: Boolean,
      default: false,
    },
    flashcard: {
      type: Object,
    },
    metadata: {
      type: Object,
    },
  },
  emits: ['flashcard-aa-clicked'],
  data() {
    return {
      exhibitModalVisibility: false,
    };
  },
  computed: {
    casesEnabled() {
      const pv = this.$store.getters['productVars/get']['flashcards_disable_case_ids'];
      const disabled = pv && pv.value === 'true';
      return !disabled;
    },
    correctText() {
      return this.$route?.params?.userCertificationId ? 'Correct, 1 Credit Earned!' : 'Correct';
    },
    exhibitItems() {
      if (!this.flashcard.exhibit) {
        return [];
      } else if (this.flashcard.exhibit.items.length === 0) {
        return [];
      }

      const items = this.flashcard.exhibit.items;
      return items.sort((a, b) => (a.number - b.number));
    },
    exhibitsEnabled() {
      const pv = this.$store.getters['productVars/get']['flashcards_disable_exhibit_ids'];
      const disabled = pv && pv.value === 'true';
      return !disabled && this.exhibitItems.length > 0;
    },
    sata() {
      return (this.flashcard.type === 'Multiple Choice' && this.flashcard.answers.filter(a => a.correct).length > 1) || this.flashcard.type === 'SATA';
    },
    showMetadata() {
      return this.answered && this.metadata?.isValid;
    },
  },
  methods: {
    closeExhibitModal() {
      this.exhibitModalVisibility = false;
    },
    showExhibits() {
      this.exhibitModalVisibility = true;
    },
  },
};
</script>

<style lang='scss' scoped>
.question-component-container {
  .sata {
    color: #000000;
    font-size: rem-calc(14);
    font-weight: $semi-bold;
    margin-bottom: rem-calc(16);
  }

  .associated-exhibits {
    width: rem-calc(108);
    height: rem-calc(30);
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(to top, #f2f4f7, #ffffff);
    border: 1px rgba(0, 0, 0, 0.1) solid;
    color: #354052;
    font-size: rem-calc(14);
    font-weight: 600;
    margin: 0 0 rem-calc(24) 0;
    cursor: pointer;
    &:hover {
      background: linear-gradient(to top, #eeeeee, #ffffff);
    }
  }
}
</style>
